import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import Titulo from '../comum/Titulo';
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos';
import buscarTiposPreco from '../../actions/preco/buscarTiposPreco';
import { PERFIL_ADMIN } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import 'moment/locale/pt-br'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment';
import { maxValueMonetario, renderFieldMonetarioLabelEncima, renderFieldSelect, required, requiredSelect } from '../../util/inputs';
import selecionarVeiculoItinerario from '../../actions/itinerario/selecionarVeiculoItinerario';
import limparVeiculoItinerarioSelecionado from '../../actions/itinerario/limparVeiculoItinerarioSelecionado';
import { showAlertMsg, showSuccessMsg } from '../../util/messagesUtil';
import { renderFieldCheck } from '../../util/inputs';
import salvarDisponibilidadeVeiculo from '../../actions/disponibilidade-veiculo/salvarDisponibilidadeVeiculo';
import ModalCadastroBloqueioPorPeriodoDisponibilidadeVeiculo from './ModalCadastroBloqueioPorPeriodoDisponibilidadeVeiculo';
import { gerarHashForString } from '../../util/stringUtil';
import ReactTooltip from 'react-tooltip';
import qs from 'qs';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

export class PainelCadastroCalendarioDisponibilidadeVeiculo extends Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
        this.state = {
            dataInicio: null, dataFim: null,
            categoriasDisponibilidadesVeiculo: [],
            habilitaCamposCategoria: false,
            periodosBloqueados: [],
            retorno: '/painel-lista-calendario-disponibilidade-veiculo'
        }
    }

    componentDidMount() {
        this.props.limparVeiculoItinerarioSelecionado();
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        if (parametros.tipo == 'agrupado') {
            this.setState({retorno: '/painel-calendario-disponibilidade-veiculo'})
        } else if (this.props.disponibilidadeVeiculoSelecionado 
                && this.props.disponibilidadeVeiculoSelecionado.veiculo.id) {
            const url = `${this.state.retorno}?veiculo=${this.props.disponibilidadeVeiculoSelecionado.veiculo.id}`;
            this.setState({retorno: url });
        }

        this.props.buscarTiposPreco();
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.buscarVeiculos(this.props.empresaSelecionada.id, null, null, null, false);
        }

        this.carregarFormulario();
    }

    carregarFormulario() {
        if (this.props.disponibilidadeVeiculoSelecionado.veiculo.descricao) {
            this.props.changeFieldValue('formularioPainelCadastroCalendarioDisponibilidadeVeiculo',
                'veiculo', {
                label: `${this.props.disponibilidadeVeiculoSelecionado.veiculo.descricao}`,
                value: this.props.disponibilidadeVeiculoSelecionado.veiculo
            });
        }

        let categoriasDisponibilidadesVeiculo = [];
        if (this.props.disponibilidadeVeiculoSelecionado.categoriasDisponibilidadeVeiculo) {
            categoriasDisponibilidadesVeiculo = this.props.disponibilidadeVeiculoSelecionado.categoriasDisponibilidadeVeiculo.map(it => {
                return {
                    tipoPrecoVeiculo: { label: it.categoria.valor, value: it.categoria.chave },
                    habilitadoValorKm: it.habilitadoValorKm,
                    valorKm: it.valorKm,
                    habilitadoValorDiaria: it.habilitadoValorDiaria,
                    valorDiaria: it.valorDiaria,
                    habilitadoPrecoKmMaisDiaria: it.habilitadoPrecoKmMaisDiaria,
                    precoKm: it.precoKm,
                    precoDiaria: it.precoDiaria
                }
            });

        }

        let bloqueioDisponibilidadeVeiculo = [];
        if (this.props.disponibilidadeVeiculoSelecionado.bloqueioDisponibilidadeVeiculo) {
            bloqueioDisponibilidadeVeiculo = this.props.disponibilidadeVeiculoSelecionado.bloqueioDisponibilidadeVeiculo.map(it => {
                return {
                    hash: gerarHashForString(`${moment(it.dataInicio)}-${moment(it.dataFim)}`),
                    ...it
                }
            })
        }

        this.setState({
            dataInicio: this.props.disponibilidadeVeiculoSelecionado.dataInicio,
            dataFim: this.props.disponibilidadeVeiculoSelecionado.dataFim,
            categoriasDisponibilidadesVeiculo: categoriasDisponibilidadesVeiculo,
            habilitaCamposCategoria: false,
            periodosBloqueados: bloqueioDisponibilidadeVeiculo
        })

    }

    getTipoPreco() {
        return this.props.tiposPreco.filter(it => this.state.categoriasDisponibilidadesVeiculo.filter(cat => cat.tipoPrecoVeiculo.value === it.tipoPreco).length <= 0);
    }

    exibirComboTipoPreco(name, label) {
        return <><Field name={name}
            options={this.getTipoPreco().map(elemento => ({
                descricao: elemento.descricaoTipoPreco,
                nome: elemento.tipoPreco
            }))}
            component={renderFieldSelect}
            label={label}
            placeholder='Selecione a categoria'
            validate={requiredSelect} /></>
    }

    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        minDate.setDate(minDate.getDate())
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }

    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({ dataInicio: data, dataFim: null })
        } else {
            this.setState({ data, dataFim: data })
        }
    }

    naoPossuiCategoriaDisponibilidade() {
        return this.state.categoriasDisponibilidadesVeiculo.length == 0
    }

    exibirBotaoAdicionarCategorias() {
        return (
            <div className="row col-md-12 mb-4">
                <div className="row col-md-4">
                    <button className="btn btn-laranja" onClick={(e) => {
                        e.preventDefault()
                        this.setState({ habilitaCamposCategoria: true })
                    }}>
                        Adicionar Categorias
                    </button>
                </div>
            </div>
        )
    }

    handleSelecionarVeiculo(evento) {
        this.props.selecionarVeiculoItinerario(evento);
    }

    removerCategoriaSelecionada(valor) {
        this.setState({ categoriasDisponibilidadesVeiculo: this.state.categoriasDisponibilidadesVeiculo.filter(it => !(it.tipoPrecoVeiculo.value === valor)) })
    }

    adicionarCategoria(event) {
        event.preventDefault();
        if (this.state.categoriasDisponibilidadesVeiculo.filter(it => it.tipoPrecoVeiculo.value === this.props.tipoPrecoVeiculo.value).length === 0) {
            if (this.props.habilitadoValorKm && !this.props.valorKm) {
                showAlertMsg('O campo valor km é obrigatório');
                return;
            }

            if (this.props.habilitadoValorDiaria && !this.props.valorDiaria) {
                showAlertMsg('O campo valor diária é obrigatório');
                return;
            }

            if (this.props.habilitadoPrecoKmMaisDiaria && !this.props.precoKm && !this.props.precoDiaria) {
                showAlertMsg('O campo valor km e valor diária são obrigatório');
                return;
            }

            if (!this.props.habilitadoValorKm && !this.props.habilitadoValorDiaria && !this.props.habilitadoPrecoKmMaisDiaria) {
                showAlertMsg('Nenhum valor foi habilitado para categoria');
                return;
            }

            const categorias = this.state.categoriasDisponibilidadesVeiculo;
            categorias.push({
                tipoPrecoVeiculo: this.props.tipoPrecoVeiculo,
                habilitadoValorKm: this.props.habilitadoValorKm,
                valorKm: this.props.habilitadoValorKm ? this.props.valorKm : null,
                habilitadoValorDiaria: this.props.habilitadoValorDiaria,
                valorDiaria: this.props.habilitadoValorDiaria ? this.props.valorDiaria : null,
                habilitadoPrecoKmMaisDiaria: this.props.habilitadoPrecoKmMaisDiaria,
                precoKm: this.props.habilitadoPrecoKmMaisDiaria ? this.props.precoKm : null,
                precoDiaria: this.props.habilitadoPrecoKmMaisDiaria ? this.props.precoDiaria : null
            });
            this.setState({ categoriasDisponibilidadesVeiculo: categorias });

            this.limparCamposCategoria();
        }
    }

    limparCamposCategoria() {
        const tiposPreco = this.getTipoPreco();
        if (tiposPreco && tiposPreco.length > 0) {
            const elemento = tiposPreco[0]
            this.props.changeFieldValue('formularioPainelCadastroCalendarioDisponibilidadeVeiculo',
            'tipoPrecoVeiculo', {
                label: elemento.descricaoTipoPreco,
                value: elemento.tipoPreco
            });
        }
        
        this.props.changeFieldValue('formularioPainelCadastroCalendarioDisponibilidadeVeiculo', 
        'habilitadoValorKm', false)
        this.props.changeFieldValue('formularioPainelCadastroCalendarioDisponibilidadeVeiculo',
            'valorKm', '');
        this.props.changeFieldValue('formularioPainelCadastroCalendarioDisponibilidadeVeiculo', 
        'habilitadoValorDiaria', false)
        this.props.changeFieldValue('formularioPainelCadastroCalendarioDisponibilidadeVeiculo',
            'valorDiaria', '');
        this.props.changeFieldValue('formularioPainelCadastroCalendarioDisponibilidadeVeiculo', 
            'habilitadoPrecoKmMaisDiaria', false)
        this.props.changeFieldValue('formularioPainelCadastroCalendarioDisponibilidadeVeiculo',
            'precoKm', '');
        this.props.changeFieldValue('formularioPainelCadastroCalendarioDisponibilidadeVeiculo',
            'precoDiaria', '');
    }

    exibirIconeValorkmMaisValorDiaria(isValorKm = false) {
        return <><span className="align-self-center tooltip-info">
            <a data-tip data-for={`tooltip-valorkm-valordiaria-${isValorKm}`}>
                <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
            </a>
            <span className="tooltip-ut">
                <ReactTooltip className="tooltip-ut" id={`tooltip-valorkm-valordiaria-${isValorKm}`}
                    type="dark" effect="solid">
                    <div className="row">{isValorKm ? <span>Esse valor será multiplicado pela quantidade de quilometros gerado na viagem</span> : <span>Esse valor será multiplicado pela quantidade de diárias na excursão</span>}</div>
                </ReactTooltip>
            </span>
        </span></>
    }

    exibirCategoriasSelecionadas() {
        return (
            <table className="table table-sm table-bordered">
                <thead>
                    <tr className='text-center'>
                        <th colSpan='5'>Categorias</th>
                    </tr>
                    <tr>
                        <th>Categoria</th>
                        <th>Valor km</th>
                        <th>Valor Diária</th>
                        <th>{this.exibirIconeValorkmMaisValorDiaria(true)} Valor km + {this.exibirIconeValorkmMaisValorDiaria()} Valor Diária</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {!this.state.categoriasDisponibilidadesVeiculo || this.state.categoriasDisponibilidadesVeiculo.length === 0 ?
                        <tr className="alert alert-warning text-center mt-4" role="alert">
                            <td colSpan='5'>Nenhuma categoria selecionada.
                            </td>
                        </tr>
                        :
                        this.state.categoriasDisponibilidadesVeiculo
                            .map((categoria, i) => <tr key={i}>
                                <td>
                                    {categoria.tipoPrecoVeiculo.label}
                                </td>
                                {categoria.habilitadoValorKm ? <td>{categoria.valorKm}</td> : <td style={{ textAlign: 'center' }}>-</td>}
                                {categoria.habilitadoValorDiaria ? <td>{categoria.valorDiaria}</td> : <td style={{ textAlign: 'center' }}>-</td>}
                                {categoria.habilitadoPrecoKmMaisDiaria ? <td>{categoria.precoKm} + {categoria.precoDiaria}</td> : <td style={{ textAlign: 'center' }}>-</td>}
                                <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                    <div
                                        onClick={() => this.removerCategoriaSelecionada(categoria.tipoPrecoVeiculo.value)}
                                    >Remover
                                    </div>
                                </td>
                            </tr>)}
                </tbody>
            </table>
        )

    }

    valiarSePeriodoDeBloqueioTemInterseccao(dataInicioBloqueio, dataFimBloqueio, dataInicio, dataFim) {
        return dataInicioBloqueio >= dataInicio && dataInicioBloqueio <= dataFim
            || dataFimBloqueio >= dataInicio && dataFimBloqueio <= dataFim;
    }

    adicionarBloqueoDisponibilidadeVeiculo(bloqueio) {
        if (this.state.periodosBloqueados.filter(it => it.hash === bloqueio.hash).length === 0) {
            const bloqueios = this.state.periodosBloqueados;
            bloqueios.push(bloqueio);
            this.setState({ periodosBloqueados: bloqueios });
        }
    }

    removerBloqueioDisponibilidadeVeiculo(hash) {
        this.setState({ periodosBloqueados: this.state.periodosBloqueados.filter(it => !(it.hash == hash)) });

    }

    exibirBotaoAdicionarBloqueios() {
        return (
            <div className="row col-md-12 mb-4">
                <div className="row col-md-4">
                    <button className="btn btn-laranja"
                        data-toggle="modal"
                        data-target="#modalCadastroBloqueioPorPeriodoDisponibilidadeVeiculo"
                        onClick={(e) => e.preventDefault()}>
                        Adicionar Bloqueios
                    </button>
                </div>
            </div>
        )
    }

    exibirBloqueiosSelecionadas() {
        return (
            <table className="table table-sm table-bordered">
                <thead>
                    <tr className='text-center'>
                        <th colSpan='4'>Períodos Bloqueados</th>
                    </tr>
                    <tr>
                        <th>Data Início</th>
                        <th>Data Fim</th>
                        <th>Motivo</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {!this.state.periodosBloqueados || this.state.periodosBloqueados.length === 0 ?
                        <tr className="alert alert-warning text-center mt-4" role="alert">
                            <td colSpan='4'>Nenhuma categoria selecionada.
                            </td>
                        </tr>
                        : this.state.periodosBloqueados.map((it, index) => (
                            <tr key={`periodo-bloqueado-${index}`}>
                                <td>{moment(it.dataInicio).format('DD/MM/YYYY')}</td>
                                <td>{moment(it.dataFim).format('DD/MM/YYYY')}</td>
                                <td>{it.motivo}</td>
                                <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                    <div
                                        onClick={() => this.removerBloqueioDisponibilidadeVeiculo(it.hash)}
                                    >Remover
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        )
    }

    montarParametros() {
        return {
            id: this.props.disponibilidadeVeiculoSelecionado.id,
            dataInicio: this.state.dataInicio,
            dataFim: this.state.dataFim,
            veiculoId: this.props.veiculo.value ? this.props.veiculo.value.id : null,
            empresaId: this.props.empresaSelecionada.id,
            categoriaDisponibilidadeVeiculoDto: this.state.categoriasDisponibilidadesVeiculo.map(it => {
                return {
                    categoria: it.tipoPrecoVeiculo.value,
                    habilitadoValorKm: it.habilitadoValorKm,
                    valorKm: it.habilitadoValorKm ? it.valorKm.replace('R$', '') : null,
                    habilitadoValorDiaria: it.habilitadoValorDiaria,
                    valorDiaria: it.habilitadoValorDiaria ? it.valorDiaria.replace('R$', '') : null,
                    habilitadoPrecoKmMaisDiaria: it.habilitadoPrecoKmMaisDiaria,
                    precoKm: it.habilitadoPrecoKmMaisDiaria ? it.precoKm.replace('R$', '') : null,
                    precoDiaria: it.habilitadoPrecoKmMaisDiaria ? it.precoDiaria.replace('R$', '') : null
                }
            }),
            periodoBloqueado: this.state.periodosBloqueados
        };
    }

    submit() {
        this.props.salvarDisponibilidadeVeiculo(this.montarParametros()).then(() => {
            showSuccessMsg('O calendário disponibilidade veículo foi salvo com sucesso');
            this.props.history.push(this.state.retorno);
        })
    }

    render() {
        const { handleSubmit, invalid, submitting } = this.props;

        return (
            <div>
                <div className="row internas">
                    <Titulo texto={`Painel ${this.props.disponibilidadeVeiculoSelecionado.veiculo.id ? 'Edição' : 'Cadastro'} Calendario`} urlRetorno={this.state.retorno} />
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                <li className="nav-item dropdown nome-empresa">
                                    <div className='col-md-6'>
                                        <CampoSelecionarEmpresa />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Autorizacao>
                </div>
                <div>
                    <form onSubmit={handleSubmit(this.submit)}>
                        <fieldset className="scheduler-border">
                            <legend className="scheduler-border">Informações básicas</legend>
                            <div className="col-12 col-sm-4 col-md-2 mt-2">
                                <label>Data de início</label>
                                <div className='form-row'>
                                    {this.exibirCalendario(true)}
                                </div>
                            </div>
                            <div className="col-12 col-sm-4 col-md-2 mt-2">
                                <label>Data fim</label>
                                <div className='form-row'>
                                    {this.exibirCalendario()}
                                </div>
                            </div>
                            <div className="col-12 col-sm-4 col-md-4">
                                <Field name='veiculo'
                                    options={this.props.veiculos.map(elemento => ({
                                        descricao: elemento.descricao,
                                        nome: elemento
                                    }))}
                                    component={renderFieldSelect}
                                    label="Veículo"
                                    disabled={this.props.disponibilidadeVeiculoSelecionado.veiculo.id}
                                    placeholder='Selecione um veículo' validate={requiredSelect}
                                    onChange={(e) => this.handleSelecionarVeiculo(e)} />
                            </div>
                        </fieldset>
                        <fieldset className="scheduler-border">
                            <legend className="scheduler-border">Configuração categoria</legend>

                            {this.state.habilitaCamposCategoria && <><div className="col-12 col-sm-4 col-md-3 mb-2">
                                {this.exibirComboTipoPreco('tipoPrecoVeiculo', 'Categoria')}
                            </div>
                                <div className="col-12 col-sm-12 col-md-12 mt-3 mb-3">
                                    <div className='form-row' style={{ alignItems: 'flex-end' }}>
                                        <div className="col-12 col-sm-3 col-md-3"><Field
                                            name="habilitadoValorKm"
                                            type="checkbox"
                                            component={renderFieldCheck}
                                            label="Habilitar Valor Km"
                                            css="form-check-input"
                                        /></div>

                                        {this.props.habilitadoValorKm && <div className="col-12 col-sm-3 col-md-2"><Field name="valorKm" validate={[required, maxValueMonetario]}
                                            component={renderFieldMonetarioLabelEncima}
                                            label="Valor km"
                                            css="form-check-input"
                                        /></div>}
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 mb-3">
                                    <div className='form-row' style={{ alignItems: 'flex-end' }}>
                                        <div className="col-12 col-sm-3 col-md-3"><Field
                                            name="habilitadoValorDiaria"
                                            type="checkbox"
                                            component={renderFieldCheck}
                                            label="Habilitar Valor Diária"
                                            css="form-check-input"
                                        /></div>

                                        {this.props.habilitadoValorDiaria && <div className="col-12 col-sm-3 col-md-2">
                                            <Field name="valorDiaria" validate={[required, maxValueMonetario]}
                                                component={renderFieldMonetarioLabelEncima}
                                                label="Valor Diária"
                                            />
                                        </div>}
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12">
                                    <div className='form-row' style={{ alignItems: 'flex-end' }}>
                                        <div className="col-12 col-sm-3 col-md-3"><Field
                                            name="habilitadoPrecoKmMaisDiaria"
                                            type="checkbox"
                                            component={renderFieldCheck}
                                            label="Habilitar Valor Km + valor Diária"
                                            css="form-check-input"
                                        /></div>

                                        {this.props.habilitadoPrecoKmMaisDiaria && <><div className='col-12 col-sm-3 col-md-2 mr-2'><Field name="precoKm" validate={[required, maxValueMonetario]}
                                                component={renderFieldMonetarioLabelEncima}
                                                label="Valor km"
                                            /></div>
                                            <div className='col-12 col-sm-3 col-md-2 mr-2'><Field name="precoDiaria" validate={[required, maxValueMonetario]}
                                                component={renderFieldMonetarioLabelEncima}
                                                label='Valor Diária'
                                            /></div></>}
                                    </div>
                                </div>


                                <div className="col-12 col-sm-12 col-md-12 mt-3 mb-3">
                                    <button
                                        disabled={!this.props.tipoPrecoVeiculo}
                                        type="submit" className="btn btn-sm btn-laranja"
                                        onClick={(e) => this.adicionarCategoria(e)}
                                    >Incluir
                                    </button>
                                </div></>}
                            <div className="col-12 col-sm-12 col-md-10 mt-2">
                                {!this.state.habilitaCamposCategoria && this.exibirBotaoAdicionarCategorias()}
                                <div className="lista-table">
                                    {this.exibirCategoriasSelecionadas()}
                                </div>
                            </div>
                        </fieldset>
                        <fieldset className="scheduler-border">
                            <legend className="scheduler-border">Configuração Bloqueio Período</legend>
                            <div className="col-12 col-sm-12 col-md-10 mt-2">
                                {this.exibirBotaoAdicionarBloqueios()}
                                <div className="lista-table">
                                    {this.exibirBloqueiosSelecionadas()}
                                </div>
                            </div>
                        </fieldset>
                        <div className="modal-footer">
                            <button type="submit"
                                disabled={invalid || submitting || !this.state.dataInicio
                                    || !this.state.dataFim || this.naoPossuiCategoriaDisponibilidade()}
                                className="btn btn-laranja">Salvar
                            </button>
                        </div>
                    </form>
                </div>
                <ModalCadastroBloqueioPorPeriodoDisponibilidadeVeiculo
                    periodosBloqueados={this.state.periodosBloqueados}
                    adicionarBloqueio={this.adicionarBloqueoDisponibilidadeVeiculo.bind(this)}
                    valiarSePeriodoDeBloqueioTemInterseccao={this.valiarSePeriodoDeBloqueioTemInterseccao.bind(this)} />
            </div>
        )
    }
}

export const mapStateToProps = state => (
    {
        veiculos: state.veiculos.veiculos,
        tiposPreco: state.tiposPreco,
        empresaSelecionada: state.empresaSelecionada,
        disponibilidadeVeiculoSelecionado: state.disponibilidadeVeiculoSelecionado,
        veiculo: formValueSelector('formularioPainelCadastroCalendarioDisponibilidadeVeiculo')(state, 'veiculo'),
        valorKm: formValueSelector('formularioPainelCadastroCalendarioDisponibilidadeVeiculo')(state, 'valorKm'),
        valorDiaria: formValueSelector('formularioPainelCadastroCalendarioDisponibilidadeVeiculo')(state, 'valorDiaria'),
        tipoPrecoVeiculo: formValueSelector('formularioPainelCadastroCalendarioDisponibilidadeVeiculo')(state, 'tipoPrecoVeiculo'),
        habilitadoValorKm: formValueSelector('formularioPainelCadastroCalendarioDisponibilidadeVeiculo')(state, 'habilitadoValorKm'),
        habilitadoValorDiaria: formValueSelector('formularioPainelCadastroCalendarioDisponibilidadeVeiculo')(state, 'habilitadoValorDiaria'),
        habilitadoPrecoKmMaisDiaria: formValueSelector('formularioPainelCadastroCalendarioDisponibilidadeVeiculo')(state, 'habilitadoPrecoKmMaisDiaria'),
        precoKm: formValueSelector('formularioPainelCadastroCalendarioDisponibilidadeVeiculo')(state, 'precoKm'),
        precoDiaria: formValueSelector('formularioPainelCadastroCalendarioDisponibilidadeVeiculo')(state, 'precoDiaria'),
    }
);

export default withRouter(connect(mapStateToProps, {
    selecionarVeiculoItinerario,
    limparVeiculoItinerarioSelecionado,
    buscarVeiculos,
    buscarTiposPreco,
    salvarDisponibilidadeVeiculo,
    changeFieldValue
})(reduxForm({
    form: 'formularioPainelCadastroCalendarioDisponibilidadeVeiculo'
})(PainelCadastroCalendarioDisponibilidadeVeiculo)))